import React, {useEffect, useState} from "react";
import axios from "axios";
import {IInitialCount} from 'src/hooks/apis/useGetArbaeenCountDataOnRegisterTime';
import Statistic from 'src/containers/Guild/components/Statistic';
import groupIcon from 'src/assets/images/icons/all-group.svg';
import pilgrimList from 'src/assets/images/icons/pilgrim-list.svg';
import passport from 'src/assets/images/icons/passport.svg';
// import greenwemen from 'src/assets/images/icons/woman-pilgrim.svg';
// import menEarth from 'src/assets/images/icons/foreigner-man.svg';
// import wemenEarth from 'src/assets/images/icons/foreigener-woman.svg';
// import manPilgrim from 'src/assets/images/icons/man-pilgrim.svg';
import earthPersons from 'src/assets/images/icons/pilgrim-foreigner.svg';
import arbaeenService from "../../../../services/arbaeen.service";
import redPeopleIcon from "../../../../assets/images/icons/map-red-people.svg";
import greenPeopleIcon from "../../../../assets/images/icons/green-map-people.svg";


interface IProps {
  loading: boolean;
  pilgrims: IInitialCount;
}

const initialValue = {
  borderId: '',
  enteringCount: 0,
  exitingCount: 0,
};

const OverviewPilgrimCount: React.FC<IProps> = ({pilgrims, loading}) => {


  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [loadingCentralBank, setLoadingCentralBank] = useState(false)
  const [centralBankValue, setCentralBankValue] = useState(false)

  const getCentralBankCount = async () => {
    setLoadingCentralBank(true);

    try {
      const {data: result} = await arbaeenService.getCentralBankCount();

      setCentralBankValue(result.value)

      setLoadingCentralBank(false);
    } catch (err: any) {
      if (err.message === 'cancel') {
        setLoadingCentralBank(true);
        return;
      }
      setLoadingCentralBank(false);
    }
  };

  useEffect(() => {
    getCentralBankCount()
  }, [])

  const [loadingPilgrimsTransformation, setLoading] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [pilgrimsTransformation, setPilgrimsTransformation] = useState<any>(initialValue);
  const {CancelToken} = axios;
  const source = CancelToken.source();

  const getAllPilgrims = async () => {
    setLoading(true);
    try {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const {data} = await arbaeenService.gerBorderTraffic({}, {cancelToken: source.token});

      setPilgrimsTransformation({...data});
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllPilgrims();
    setInterval(() => {
      getAllPilgrims();
    }, 60000 * 5)
    return () => {
      source.cancel('Operation canceled by the user.');
    };
  }, []);
  return (
    <>
      <fieldset className="text-center border rounded-xl p-4 mb-16">
        <legend className="text-black mx-auto px-3">نگاه کلی به تعداد زائران اربعین در کشور</legend>

        <div className="flex flex-col justify-between space-y-8">
          <div
            className="flex flex-col md:flex-row justify-between space-y-5 md:space-y-0 space-x-0 md:space-x-5 rtl:space-x-reverse">

            <Statistic
              icon={groupIcon}
              text=" تعداد کل ثبت نام شدگان نهایی ایرانی"
              count={pilgrims.countIranian || 0}
              loading={loading}
            />
            <Statistic
              icon={earthPersons}
              text=" تعداد کل ثبت نام شدگان نهایی اتباع خارجی"
              count={pilgrims.countNonIranian || 0}
              loading={loading}
            />
            <Statistic
              icon={passport}
              text="تعداد کل زائرین ثبت نام شده (ایرانی و خارجی)"
              count={pilgrims.countTotal || 0}
              loading={loading}
            />
            {/*
                        <Statistic
              icon={manPilgrim}
              text=" تعداد کل ثبت نام شدگان نهایی ایرانی مرد"
              count={pilgrims.countMaleIranian || 0}
              loading={loading}
            />
            <Statistic
              icon={greenwemen}
              text="تعداد کل ثبت نام شدگان نهایی ایرانی زن"
              count={pilgrims.countFemaleIranian || 0}
              loading={loading}
            />
            */}

          </div>
          <div
            className="flex flex-col md:flex-row justify-between space-y-5 md:space-y-0 space-x-0 md:space-x-5 rtl:space-x-reverse">

            <Statistic
              icon={pilgrimList}
              text="تعداد دریافت کنندگان ارز زیارتی"
              count={centralBankValue}
              loading={loadingCentralBank}
              hasInfo
              infoText="تعداد زائرینی که توسط بانک مرکزی ارز مسافرتی دریافت نموند."
            />
            <Statistic
              icon={redPeopleIcon}
              text="تعداد  زائرین خارج شده از کشور"
              count={pilgrimsTransformation.exitingCount || 0}
              loading={loadingPilgrimsTransformation}
              hasInfo
              infoText="تعداد زائرین خارج شده از کشور از مرزهای (مهران ـ چذابه ـ تمرچین ـ باشماق ـ خسروی ـ شلمچه) از تاریخ ۱۴۰۳/۰۴/۱۷ تا به امروز"
            />
            <Statistic
              icon={greenPeopleIcon}
              text="تعداد زائرین وارد شده به کشور"
              count={pilgrimsTransformation.enteringCount || 0}
              loading={loadingPilgrimsTransformation}
              hasInfo
              infoText="تعداد زائرین وارد شده به کشور از مرزهای (مهران ـ چذابه ـ تمرچین ـ باشماق ـ خسروی ـ شلمچه) از تاریخ ۱۴۰۳/۰۴/۱۷ تا به امروز"
            />
            {/*
                <Statistic
              icon={menEarth}
              text="  تعداد کل ثبت نام شدگان نهایی اتباع خارجی مرد"
              count={pilgrims.countMaleNonIranian || 22}
              loading={loading}
            />
            <Statistic
              icon={wemenEarth}
              text=" تعداد کل ثبت نام شدگان نهایی اتباع خارجی زن"
              count={pilgrims.countFemaleNonIranian || 33}
              loading={loading}
            />
             */}


          </div>
        </div>
      </fieldset>
    </>
  );
};

export default OverviewPilgrimCount;
